import * as enums from "./enums";

const filters = {
  //日期格式化
  dateFormat:function(date, fmt="yyyy-MM-dd HH:mm:ss") {
    if (!date || !date instanceof Date) {
      return "";
    }
    date=new Date(date)
    var o = {
      "M+": date.getMonth() + 1, // 月份
      "d+": date.getDate(), // 日
      "H+": date.getHours(), // 小时
      "m+": date.getMinutes(), // 分
      "s+": date.getSeconds(), // 秒
      "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
      "S": date.getMilliseconds() // 毫秒
    };
    if (/(y+)/.test(fmt))
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt))
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
  },
  formatDate(value) {
    if(!value){
      return value
    }
    const today = new Date();
    const date = new Date(value);
    const isToday = today.toDateString() === date.toDateString();
    if (isToday) {
      // 如果是当天，则只返回时间部分
      return filters.df(value,'HH:mm:ss');
    } else {
      // 如果不是当天，则返回完整日期
      return value
    }
  },
  df: function (date, fmt = "yyyy-MM-dd HH:mm:ss") {
    if (!date || !date instanceof Date) {
      return "";
    }
    date = new Date(date);
    var o = {
      "M+": date.getMonth() + 1, // 月份
      "d+": date.getDate(), // 日
      "H+": date.getHours(), // 小时
      "m+": date.getMinutes(), // 分
      "s+": date.getSeconds(), // 秒
      "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
      S: date.getMilliseconds(), // 毫秒
    };
    if (/(y+)/.test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        (date.getFullYear() + "").substr(4 - RegExp.$1.length)
      );
    for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length == 1
            ? o[k]
            : ("00" + o[k]).substr(("" + o[k]).length)
        );
    return fmt;
  },
  formapt: function (i, map) {
    if (!i || !map) {
      return i;
    }
    return enums[map][i];
  },
  f: function (i, map) {
    if (i === undefined || i === null || i === "" || !map) {
      return i;
    }
    return enums[map][i];
  },
}
export default {
  install(Vue) {
      Object.keys(filters).forEach((key) => {
          Vue.filter(key, filters[key]);
      });
  },
};